import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen bg-jc-black flex items-center justify-center">
        <Loader2 className="animate-spin text-jc-gold" size={28} />
      </div>
    );
  }
  if (!user) return <Navigate to="/dashboard" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/dashboard/admin" : "/dashboard/client"} replace />;
  }
  return children;
}

export function RedirectIfAuthed({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen bg-jc-black flex items-center justify-center">
        <Loader2 className="animate-spin text-jc-gold" size={28} />
      </div>
    );
  }
  if (user) {
    return <Navigate to={user.role === "admin" ? "/dashboard/admin" : "/dashboard/client"} replace />;
  }
  return children;
}
